var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    [
      _vm.item.status === "DOCUMENTED"
        ? _c("el-tag", { attrs: { size: "mini", type: "success" } }, [
            _vm._v(_vm._s(_vm.$t("Documented"))),
          ])
        : _vm.item.status === "VERIFIED"
        ? _c("el-tag", { attrs: { size: "mini", type: "primary" } }, [
            _vm._v(_vm._s(_vm.$t("Verified"))),
          ])
        : _vm.item.status === "PENDING"
        ? _c("el-tag", { attrs: { size: "mini", type: "info" } }, [
            _vm._v(_vm._s(_vm.$t("Pending"))),
          ])
        : _vm.item.status === "SUSPENDED"
        ? _c("el-tag", { attrs: { size: "mini", type: "warning" } }, [
            _vm._v(_vm._s(_vm.$t("Suspended"))),
          ])
        : _vm.item.status === "BLACKLISTED"
        ? _c("el-tag", { attrs: { size: "mini", type: "danger" } }, [
            _vm._v(_vm._s(_vm.$t("Blacklisted"))),
          ])
        : _vm.item.status === "INACTIVE"
        ? _c("el-tag", { attrs: { size: "mini", type: "warning" } }, [
            _vm._v(_vm._s(_vm.$t("Inactive"))),
          ])
        : _vm.item.status === "DELETED"
        ? _c("el-tag", { attrs: { size: "mini", type: "danger" } }, [
            _vm._v(_vm._s(_vm.$t("Deleted"))),
          ])
        : _c("el-tag", { attrs: { size: "mini", type: "info" } }, [
            _vm._v(_vm._s(_vm.item.status)),
          ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }